import { render, staticRenderFns } from "./ArrivalCapture.vue?vue&type=template&id=065f081f&scoped=true"
import script from "./ArrivalCapture.vue?vue&type=script&lang=js"
export * from "./ArrivalCapture.vue?vue&type=script&lang=js"
import "./ArrivalCapture.vue?vue&type=style&index=0&id=065f081f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f081f",
  null
  
)

export default component.exports